"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowRight, Check } from "lucide-react";
import type { ReactNode } from "react";
import { Typography } from "@repo/ui/aops-components/typography";
import { cn } from "@repo/ui/lib/utils";
import { decorateAttributionAnchorClick, useAttributionHref } from "@repo/tracking/utm/lib/utm-attribution-client";
import styles from "./CourseButton.module.css";
export type CourseButtonProps = {
  isSelected?: boolean;
  onClick?: () => void;
  label?: ReactNode;
  selectedLabel?: ReactNode;
  className?: string;
  disabled?: boolean;
  href?: string;
  id?: string;
  target?: "_blank" | "_self";
};
export function CourseButton(t0) {
  const $ = _c(23);
  const {
    isSelected: t1,
    onClick,
    label: t2,
    selectedLabel: t3,
    className,
    disabled: t4,
    href,
    id,
    target
  } = t0;
  const isSelected = t1 === undefined ? false : t1;
  const label = t2 === undefined ? "Select" : t2;
  const selectedLabel = t3 === undefined ? "Selected" : t3;
  const disabled = t4 === undefined ? false : t4;
  const decoratedHref = useAttributionHref(href);
  const t5 = isSelected ? selectedLabel : label;
  let t6;
  if ($[0] !== t5) {
    t6 = <Typography variant="bodyMd" as="span">{t5}</Typography>;
    $[0] = t5;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className={cn(styles.buttonSpacer, "course-button-spacer")} aria-hidden={true} />;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== isSelected) {
    t8 = isSelected ? <span className={styles.checkIconWrapper} aria-hidden={true}><Check size={16} strokeWidth={2.5} /></span> : <span className={styles.arrowIcon} aria-hidden={true}><ArrowRight size={20} strokeWidth={2.5} /></span>;
    $[3] = isSelected;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== t6 || $[6] !== t8) {
    t9 = <>{t6}{t7}{t8}</>;
    $[5] = t6;
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const content = t9;
  const t10 = disabled && styles.ctaSectionDisabled;
  let t11;
  if ($[8] !== t10) {
    t11 = cn(styles.ctaSection, t10, "course-button-cta");
    $[8] = t10;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== className || $[11] !== content || $[12] !== decoratedHref || $[13] !== disabled || $[14] !== href || $[15] !== id || $[16] !== isSelected || $[17] !== onClick || $[18] !== target) {
    t12 = href ? <a id={id} href={decoratedHref ?? href} className={cn(styles.selectButton, "course-button", className)} target={target} rel={target === "_blank" ? "noopener noreferrer" : undefined} onClick={event => {
      decorateAttributionAnchorClick(event, href);
      onClick?.();
    }}>{content}</a> : <button id={id} type="button" className={cn(styles.selectButton, "course-button", className)} disabled={disabled} onClick={event_0 => {
      event_0.stopPropagation();
      onClick?.();
    }} aria-pressed={isSelected}>{content}</button>;
    $[10] = className;
    $[11] = content;
    $[12] = decoratedHref;
    $[13] = disabled;
    $[14] = href;
    $[15] = id;
    $[16] = isSelected;
    $[17] = onClick;
    $[18] = target;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t12) {
    t13 = <div className={t11}>{t12}</div>;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}